import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";

import { logout as apiLogout } from "../lib/api";
import { clearSession, getToken } from "../lib/auth";

export function useLogout() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const logout = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    const token = getToken();
    try {
      if (token) {
        try {
          await apiLogout(token);
        } catch {
          // If the server rejects (already revoked, expired, network), we still
          // clear the local session — the user clearly intends to sign out.
        }
      }
    } finally {
      clearSession();
      setLoading(false);
      navigate("/login", { replace: true });
    }
  }, [loading, navigate]);

  return { logout, loading };
}
